<template>
    <!-- 微信群设置-群列表 -->
    <div class="container">
        <div class="handle-box-search">
            <el-row>
                <el-col :span="6">
                    <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
                </el-col>
                <el-col :span="6">
                    <span style="margin-right: 10px">群ai配置</span>
                    <el-switch
                        v-model="cityStatus"
                        active-value="1"
                        inactive-value="0"
                        @change="changeMachineSwitch(cityStatus)"
                    ></el-switch>
                    <el-tooltip class="item" effect="dark" content="关闭后所有群内ai不回复消息" placement="right">
                        <i class="el-icon-question"></i>
                    </el-tooltip>
                </el-col>
            </el-row>
        </div>

        <el-table :data="tableData1" class="table" header-cell-class-name="table-header">
            <el-table-column label="群名称" prop="NickName"> </el-table-column>

            <el-table-column label="开关">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-value="1" inactive-value="0" @change="updateGroupStatusSub(scope.row)">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="editGroupSub(scope.row)"
                  >编辑
                </el-button>
              </template>
            </el-table-column>
        </el-table>

        <!-- 编辑组件 -->
        <getUserLists :isShow="edit_isShow" :data="edit_data"></getUserLists>

        <!-- element ui 原生分页组件 -->
        <!-- <div class="pagination">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="search_data.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="search_data.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="result_data.count"
            >
            </el-pagination>
        </div> -->
    </div>
</template>

<script>
var _this;
import getUserLists from "./getUserLists.vue";
export default {
    components: {
        getUserLists,
    },
    data() {
        return {
            edit_isShow:false,
            edit_data:'',

              //翻页数据
            search_data: {
                page: 1,
                limit: 10,

            },
            cityName: '',
            cityStatus: '',

            status: 0,

            // 存放表格数据
            tableData1: [],


            //获取用户列表的数据
            search_data: {},

            result_data: []
        };
    },
    created() {
        _this = this;

        _this.searchGetGroupLists(); // 刷新列表
    },

    methods: {
        editGroupSub(row){
            this.edit_isShow=!this.edit_isShow;
            this.edit_data =row.chat_room_name;
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.incomeLog();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.incomeLog();
        },
        // ai开关
        changeMachineSwitch(cityStatus) {
            _this
                .$post('/machine/changeMachineSwitch', {
                    status: cityStatus
                })
                .then((res) => {
                    this.$message.success(res.msg);
                    _this.searchGetGroupLists();
                })
                .catch((err) => {});
        },

        // 列表开关
        updateGroupStatusSub(val) {
            _this
                .$post('/machine/updateGroupStatusSub', {
                    chat_room_name: val.chat_room_name,
                    status: val.status
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.searchGetGroupLists();
                })
                .catch((err) => {});
        },
        // 搜索
        searchGetGroupLists() {

            _this.getNoGroupLists();
        },

        // 列表
        getNoGroupLists() {
            _this
                .$post('/machine/getGroupLists', _this.search_data)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData1 = res.data.result;
                    _this.result_data = res;
                    _this.cityStatus = res.data.status;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.getGroupLists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.search-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    max-width: 150px;
    display: inline-block;
    margin-left: 10px;
    margin-top: 10px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-dropdown {
    vertical-align: top;
}

.el-dropdown + .el-dropdown {
    margin-left: 15px;
}

.el-icon-arrow-down {
    font-size: 12px;
}

.search-box {
    display: flex;
}

.searchBox {
    margin: 10px;
    padding: 30px 0;
    border-radius: 15px;
    background-color: #f5f7fa !important;
    border: 1px solid #dcdfe6;
}

.title {
    display: inline-block !important;
    width: 80px !important;
    text-align: right !important;
    padding-right: 5px !important;
    box-sizing: border-box !important;
    background-color: transparent !important;
    color: #000;
    font-size: 14px;
    margin-left: 10px;
    margin-bottom: 10px;
}

.btn {
    margin-left: 10px;
}
</style>
<style>
.pri-switch-close .el-switch__core::after {
    content: '关';
    font-size: 10px;
    text-align: center;
    line-height: 16px;
    color: #ff4949;
}

.pri-switch-open .el-switch__core::after {
    content: '开';
    font-size: 10px;
    text-align: center;
    line-height: 16px;
    color: #13ce66;
}
</style>